import React from 'react';
import Profile from '../components/user/Profile';

function ProfilePage() {
  return (
    <div>
      <Profile />
    </div>
  );
}

export default ProfilePage;